export default "__VITE_ASSET__zNiT73cQ__"